import { render, staticRenderFns } from "./my_contract.vue?vue&type=template&id=bc8a58a6&scoped=true"
import script from "./my_contract.vue?vue&type=script&route=%2Foutsource%2Fmy_contract&lang=js"
export * from "./my_contract.vue?vue&type=script&route=%2Foutsource%2Fmy_contract&lang=js"
import style0 from "./my_contract.vue?vue&type=style&index=0&id=bc8a58a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8a58a6",
  null
  
)

export default component.exports